<template>
    <div class="section-container container-fixed">
        <div class="row text-center">
            <div @click="goToProfile(token)" v-for="(token, index) in tokens" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <div class="content-container mb-3">
                    <div class="content-display">
                        <img :src="getImageSrc(token)" alt="card image" width="80%">
                    </div>
                    <div class="content-label">
                        {{ token.name }} ({{ token.symbol }})
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'About',
    computed: {
        ...mapGetters({
            tokens: 'getTokens'  
        })
    },
    methods: {
        goToProfile (token) {
            this.$store.commit('setToken', { token });
            this.$router.push({ name: 'profile', params: { address: token.contract }})
        },
        getImageSrc (token) {
            return token.imageUrl == 'https://unsplash.com/photos/OSzlbMcf9Hg' ? 'http://cdn.onlinewebfonts.com/svg/img_199922.png' : token.imageUrl;
        }
    }
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";

.section-container {
    padding: 30px 20px;

    .content-container {
        cursor: pointer!important;
    }

    .token-item {
        background: #efefef;
        text-align: center;
        padding: 20px;
        
        header {
            font-size: 24px;
        }

        .token-image {
            img {
                height: 250px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Browse.vue